<template>
	<div></div>
</template>
<script>
import {mapActions } from 'vuex';

export default {
	methods: {
		...mapActions('auth', ['loginSSO']),

		async onLogin(token) {
			await this.loginSSO({ token: token }).then(() => {
				this.redirect()
			}).catch(() => {
				this.redirect()
			})
		},
		redirect() {
			this.$router.push({ name: 'transaction' });
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Login SSO');
		this.onLogin(this.$route.params.token)
	},
};
</script>